import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinOum = createAsyncThunk(
    "Oum/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"MasterOum/getMin",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        CategoryID: item.CategoryID,
                        value: item.OumID,
                        label: item.NamaOum,
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getOum = createAsyncThunk(
    "Oum/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"MasterOum/getAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertOum = createAsyncThunk(
    "Oum/insert",
    async ({NamaOum, CategoryID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("NamaOum", NamaOum);
        formData.append("CategoryID", CategoryID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"MasterOum/insert",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateOum = createAsyncThunk(
    "Oum/update",
    async ({NamaOum, OumID, status, CategoryID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("NamaOum", NamaOum);
        formData.append("OumID", OumID);
        formData.append("Status", status);
        formData.append("CategoryID", CategoryID);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"MasterOum/update",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const OumSlice = createSlice({
    name: "oum",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinOum.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinOum.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinOum.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getOum.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getOum.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getOum.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertOum.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertOum.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertOum.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateOum.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateOum.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateOum.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const OumSelector = (state) => state.oum;
